import cookie from 'react-cookies';
import config from 'util/config';
import {
  map, isEmpty, join, replace, rangeRight, get as getLodash
} from 'lodash';
import React from 'react';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import { Col, message, Icon } from 'antd';

/**
 * getUserInfo: get thông tin đăng nhập
 * @param {object} data
 */
export const getUserInfo = (data) => {
  const datas = data.authUser ? data.authUser.user : [];
  return datas;
};

/**
 * getCookieValue: Lấy cookie
 * @param {string} name
 */
export const getCookieValue = (name) => cookie.load(name);

/**
 * setCookieValue: Gán cookie
 * @param {string} name
 * @param {string} value
 */
export const setCookieValue = (name, value) => cookie.save(name, value);

/**
 * removeCookieValue: Xoá cookie value
 * @param {string} name
 */
export const removeCookieValue = (name) => cookie.remove(name, { path: '/' });

/**
 * setLocalStorage: Lưu dữ liệu vào localStorage
 * @param {string} key
 * @param {string} value
 */
export const setLocalStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));

/**
 * getLocalStorage: Lấy dữ liệu từ localStorage
 * @param {string} key
 */
export const getLocalStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
};

/**
   * removeLocalStorage: Xoá dữ liệu từ localStorage theo key
   * @param {string} key
   */
export const removeLocalStorage = (key) => localStorage.removeItem(key);

/**
   * removeAllLocalStorage: Xoá hết dữ liệu trong localStorage
   */
export const removeAllLocalStorage = () => localStorage.clear();

/**
 * setSessionStorage: Lưu dữ liệu vào session
 * @param {string} key
 * @param {string} value
 */
export const setSessionStorage = (key, value) => sessionStorage.setItem(key, JSON.stringify(value));

/**
 * getSessionStorage: Lấy dữ liệu từ sessionStorage
 * @param {string} key
 */
export const getSessionStorage = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch (error) {
    return null;
  }
};

/**
 * removeSessionStorage: Xoá dữ liệu từ sessionStorage theo key
 * @param {string} key
 */
export const removeSessionStorage = (key) => sessionStorage.removeItem(key);

/**
 * removeAllSessionStorage: Xoá hết dữ liệu trong sessionStorage
 * @returns
 */
export const removeAllSessionStorage = () => sessionStorage.clear();

/**
   * logOut: Đăng xuất
   */
export const logOut = async () => {
  await removeCookieValue('accessTokenBDT');
  await removeCookieValue('userId');
  await removeCookieValue('defaultUrl');
  await removeAllLocalStorage();
  await removeAllSessionStorage();

  if (!getCookieValue('accessTokenBDT')) {
    window.location.href = `${await config.API_URL}/saml/logout?url=${window.location.protocol}//
    ${window.location.host}${window.location.hash}`;
  }
};

/**
   * reDataForTable: Dùng cho phân trang
   * @param {object} data
   * @param {int} activePage
   * @param {int} pageSize
   */
export const reDataForTable = (data, activePage = 1, pageSize = 5000) => map(data, (item, index) => ({
  key: activePage === 1 ? index + 1 : index + (activePage - 1) * pageSize + 1,
  ...item
}));

/**
   * reDataSelectedTable: Dành cho bảng có phần select
   * Cần phải thay key mặc định bằng id mới có thể gọi select mặc định
   * @param {object} data
   */
export const reDataSelectedTable = (data) => map(data, (item, index) => {
  let tempItem = item;
  tempItem = { key: item.id, ...item };
  return tempItem;
});

/**
* formatNumber: format số
* @param {int} value
*/
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  const valueTmp = value ? value.toString().replace('.', ',') : 0;
  return valueTmp.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
};

/**
* formatNumberEx: format số excel
* @param {int} value
*/
export const formatNumberEx = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
};

/**
   * StringValueReturn : Hàm xử lý dữ liệu trên bảng (Row expand)
   * @param {string} values
   */
export function StringValueReturn(values) {
  const {
    size, type, value, text, fieldName
  } = values;
  let valueTmp;
  if (type === 'text') {
    valueTmp = value || '';
  } else if (type === 'date') {
    valueTmp = '';
    if (value) {
      valueTmp = Moment(value).format('DD/MM/YYYY');
    } else if (value !== 0) {
      valueTmp = Moment(value).format('DD/MM/YYYY');
    } else {
      valueTmp = '';
    }
  } else if (type === 'object') {
    valueTmp = value ? value[fieldName] : '';
  } else if (type === 'file') {
    valueTmp = value ? (
      <Link to={{ pathname: '/custom-views/view-pdf', state: { pdfUrl: value } }}>Xem nội dung</Link>
    ) : ('');
  } else if (type === 'html') {
    valueTmp = value ? (
      <Link
        to={{
          pathname: '/custom-views/view-html',
          state: { htmlValue: value }
        }}
      >
        Xem nội dung
      </Link>
    ) : ('');
  } else if (type === 'boolean') {
    valueTmp = value ? 'Có' : 'Không';
  } else if (type === 'gender') {
    valueTmp = value ? 'Nam' : 'Nữ';
  } else if (type === 'currency') {
    valueTmp = value ? formatNumber(value) : 0;
  } else if (type === 'VND') {
    valueTmp = value ? `${formatNumber(value)} (Đồng)` : 0;
  } else if (type === 'TrieuVND') {
    valueTmp = value ? `${formatNumber(value)} (Triệu đồng)` : 0;
  } else if (type === 'TyVND') {
    valueTmp = value ? `${formatNumber(value)}  (Tỷ đồng)` : 0;
  } else if (type === 'HA') {
    valueTmp = value ? `${formatNumber(value)}  (Hecta)` : 0;
  } else if (type === 'Tan') {
    valueTmp = value ? `${formatNumber(value)} (Tấn/năm)` : 0;
  } else if (type === 'km') {
    valueTmp = value ? `${value} (km)` : 0;
  } else if (type === 'kV') {
    valueTmp = value ? `${value} (kV)` : 0;
  } else if (type === 'MW') {
    valueTmp = value ? `${value} (MW)` : 0;
  } else if (type === 'MVA') {
    valueTmp = value ? `${value} (MVA)` : 0;
  } else if (type === 'm2') {
    valueTmp = value ? `${value} (m2)` : 0;
  } else if (type === 'array') {
    const newArr = map(value, (value) => value[fieldName]);
    valueTmp = join(newArr, ', ');
  }
  if (!isEmpty(valueTmp) || valueTmp || valueTmp === 0) {
    return (
      <Col md={size} span={8} style={{ paddingBottom: 8 }} xs={24}>
        {text}: {valueTmp}
      </Col>
    );
  }
  return null;
}

/**
   * numberLocalConvert: chuyển đổi đơn vị số bản địa
   * @param {string} value
   */
export const numberLocalConvert = (value) => {
  if (value) return value.toLocaleString();
  return 0;
};

/**
   * convertPhoneNumber: Hàm convert số điện thoại *
   * @param {string} e
   */
export const convertPhoneNumber = (e) => {
  if (e) {
    let value = e;
    value = value.replace(/[ .,]/g, '');
    let valueNumber;
    if (value && value.length === 10) {
      valueNumber = value.toString().match(/\b(?=(\d{4})+(\d{3})+(\d{3}))/);
      valueNumber.shift();
      valueNumber = valueNumber.join('.');
    } else if (value && value.length === 11) {
      valueNumber = value.toString().match(/\b(?=(\d{5})+(\d{3})+(\d{3}))/);
      valueNumber.shift();
      valueNumber = valueNumber.join('.');
    } else {
      value = e;
    }
    return valueNumber;
  }
  return e;
};

/**
   * Xoá tất cả dấu "," trong string
   * @param {string} value
   */
export const removeAllComma = (value) => {
  let valueTmp = value.toString();
  valueTmp = replace(valueTmp, new RegExp(',', 'g'), '');
  return valueTmp;
};

// Pattern : validate số trong string (ví dụ : số điện thoại...)
export const onlyAcceptNumberInString = '^\\S[0-9 ~!@#$%^&*()_+-=|\\/]+\\S$';

/**
   * StringValueReturn : Hàm xử lý xuât excel dữ liệu trên bảng
   * @param {string} classId
   * @param {string} docName
   */
export const handleExportExcelFunc = (classId, docName) => {
  const dataTime = Moment(new Date()).format('DD_MM_YYYY_HH_ss');
  setTimeout(() => {
    const table = document.getElementById(classId).innerHTML;
    // eslint-disable-next-line max-len
    const styles = '<style> .rotate { mso-rotate: 90; white-space:nowrap } table tr td {border: thin solid #000 !important; color: #393939 !important} table tr.noBorder td {border: 0 !important } </style>';
    const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->${styles}</head><body><table>${table}</table></body></html>`; const myBlob = new Blob([template], {
      type: 'application/vnd.ms-excel;charset=utf-8,'
    });
    const url = window.URL.createObjectURL(myBlob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = url;
    a.download = `${docName}_${dataTime}.xls`;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 0);
  }, 1000);
};

/**
   * Hàm xuất MS Word
   * @param {string} elementId
   * @param {string} [docName='']
   */
export const handleExportWordFunc = (elementId, docName = '') => {
  const preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
  const postHtml = '</body></html>';
  if (document.getElementById(elementId)) {
    const html = preHtml + document.getElementById(elementId).innerHTML + postHtml;
    const blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    // Specify link url
    const url = `data:application/vnd.ms-word;charset=utf-8,${encodeURIComponent(html)}`;
    // Specify file name
    let tempDocName = docName;
    tempDocName = docName ? `${docName}.doc` : 'document.doc';
    // Create download link element
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, tempDocName);
    } else {
      // Create a link to the file
      downloadLink.href = url;
      // Setting the file name
      downloadLink.download = tempDocName;
      // triggering the function
      downloadLink.click();
    }
    document.body.removeChild(downloadLink);
  }
};

/**
   * Trả về ngày tháng long - date 'DD/MM/YYYY'
   * @param {date} value
   */
export const longToDate = (value) => {
  if (value === 0 || value === null || value === undefined) {
    return '';
  }
  return Moment(value).format('DD/MM/YYYY');
};

/**
   * Trả về ngày tháng trong khoảng ngày từ ngày 1-1 năm hiện tại tới 23:59:59 ngày hiện tại
   * @param {string} status
   */
export const getDateRangerInTheCurrentYear = (status) => {
  let dateTmp = new Date();
  const fullYear = dateTmp.getFullYear();
  let month = '01';
  let date = '01';
  let hour = '00:00:00';
  if (status === 'denNgay') {
    month = dateTmp.getMonth() + 1;
    month = month.length === 1 ? `0${month}` : month;
    date = dateTmp.getDate();
    hour = '23:59:59';
    dateTmp = `${date}-${month}-${fullYear} ${hour}`;
  } else {
    dateTmp = `${date}-${month}-${fullYear} ${hour}`;
  }
  return dateTmp;
};

/**
   * Trả về ngày tháng trong khoảng ngày từ ngày (theo quy định) đến ngày hiện tại
   * Đối với thành phần này là trừ bao nhiêu ngày, tháng, năm
   * @param {string} status - tuNgay, denNgay
   * @param {string} type - theoNgay, theoThang, theoNam
   * @param {string} data - trừ bao nhiêu
   */
export const getDateRangerHandle = (status, type = '', data = '') => {
  let dateTmp = new Date();
  const fullYear = dateTmp.getFullYear();
  if (status === 'denNgay') {
    dateTmp.setHours(24);
    dateTmp.setMinutes(59);
    dateTmp.setSeconds(59);
    dateTmp = Moment(dateTmp).format('DD/MM/YYYY HH:mm:ss');
  } else {
    if (type === 'theoNgay') {
      dateTmp.setDate(dateTmp.getDate() - data);
      dateTmp = Moment(dateTmp).format('DD/MM/YYYY HH:mm:ss');
    }
    if (type === 'theoThang') {
      dateTmp.setMonth(dateTmp.getMonth() - data);
      dateTmp = Moment(dateTmp).format('DD/MM/YYYY HH:mm:ss');
    }
    if (type === 'theoNam') {
      dateTmp.setFullYear(fullYear - data);
    }
  }
  return dateTmp;
};

/**
   * addAllValue : hàm get all value ( ví dụ : xã phường )
   * @param {array} array
   * @param {string} [type='diaPhuong']
   */
export const addAllValue = (array, type = 'diaPhuong', object) => {
  if (type === 'diaPhuong') {
    return [{ id: 0, ma: '', ten: '---Tất cả---' }, ...array];
  }
  if (type === 'custom') {
    return [object, ...array];
  }
  return undefined;
};

/**
   * Tạo mảng năm dựa theo số đầu vào
   * Năm sẽ dựa từ năm hiện tại trừ đi
   * @param {int} number
   */
export const yearArrByRange = (number) => {
  const currentYear = new Date().getFullYear();
  return rangeRight(currentYear + 1, currentYear - number);
};

/**
   * renderListCurentYears: hàm lấy list năm  theo năm hiện tại
   * vd: hiện tại năm 2020 thì renderListCurentYears(5,2) trả về 2015 đến 2022
   * @param {int} backNumber // số năm muốn lùi lại so với năm hiện tại
   * @param {int} nextNumber // số năm muốn công thêm so với năm hiện tại.
   */
export const renderListCurentYears = (backNumber, nextNumber) => {
  const currentYear = new Date().getFullYear();
  const tang = rangeRight(currentYear, currentYear + nextNumber + 1);
  const giam = rangeRight(currentYear - backNumber, currentYear);
  return [...tang, ...giam];
};

/**
   * boDauTiengViet: Chuyển văn bản có dấu sang không dấu
   * @param {string} str
   * @returns Văn bản không dấu
   */
export const boDauTiengViet = (tempStr) => {
  let str = tempStr;
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  return str;
};

/**
   * getBase64: Chuyển đổi ảnh sang dạng base64
   * @param {object} img
   * @param {string} callback
   */
export const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  const dataR = reader.readAsDataURL(img);
  return dataR;
};

/**
   * beforeUpload: Check file trước khi tải lên
   * @param {object} file
   */
export const beforeUpload = (file) => {
  const isJPG = file.type === 'image/jpeg';
  if (!isJPG) {
    message.error('Bạn chỉ có thể upload JPG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Ảnh phải nhỏ hơn 2MB!');
  }
  return isJPG && isLt2M;
};

/**
   * beforeUploadLimit: Check file trước khi tải lên ko quá size MB
   * @param {number} limitSize
   * @param {object} file
   */
export const beforeUploadLimit = (limitSize, file) => {
  const isName = boDauTiengViet(file.name);
  const isFileTrue = file.size / 1024 / 1024 < limitSize;
  if (!isFileTrue) {
    message.error(`Dung lượng tải lên phải nhỏ hơn ${limitSize}MB!`);
  }
  return isFileTrue && isName;
};

/**
   * Get the datetime by format
   * @param {date} obj.value the datetime value
   * @param {string} obj.format the format which will be used to convert the value
   * @param {boolean} obj.isUTC if true, the value will be converted to UTC time (default use local time)
   * @param {boolean} obj.isString if true, the value will be returned as a string
   * @returns {moment} the moment instance
   * @memberof Helpers
   */
export const getDateTime = ({
  value = undefined, format = null, isUTC = false, isString = true
}) => {
  if (!value || !Moment(value).isValid()) {
    return undefined;
  }
  const newValue = isUTC ? Moment.utc(value) : Moment.utc(value).local();
  let result = newValue;
  if (isString && isEmpty(format)) {
    result = Moment(newValue).format();
  }
  if (isString && !isEmpty(format)) {
    result = Moment(newValue).format(format);
  }
  if (!isString && isEmpty(format)) {
    result = Moment(Moment(newValue).format());
  }
  if (!isString && !isEmpty(format)) {
    result = Moment(Moment(newValue).format(format), format);
  }
  return result;
};

/**
   * isCheck : hiển thị check trên table
   */
// eslint-disable-next-line react/no-multi-comp
export const isCheck = (check) => (
  check === true ? <Icon type="check" /> : null
);

/**
 * reData : hàm renew data listTreePhongBan
 * @param {Array} data
 */
export const reData = (data) => {
  const rs = map(data, (item) => {
    if (!isEmpty(item.children)) {
      return {
        id: item.id,
        value: item.id,
        title: item.tenDonVi,
        pId: item.parentId,
        children: reData(item.children)
      };
    }
    if (item.children === null) {
      return {
        id: item.id,
        value: item.id,
        title: item.tenDonVi,
        pId: item.parentId,
        isLeaf: true
      };
    }
    return {
      id: item.id, value: item.id, title: item.tenDonVi, pId: 0
    };
  });
  return rs;
};

/**
 * scrollToIdElement : hàm scroll tới phần tử có id là idElm
 * @param {string} idElm
 */
export const scrollToIdElement = (idElm) => {
  const section = document.querySelector(`#${idElm}`);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

/**
 * getListThangQuy : danh sách tháng theo quý
 * @param {object} listAll
 * @param {boolean} isAll
 */
export const getListThangQuy = (listAll, isAll = true) => {
  const newThang = [...listAll];
  if (isAll) {
    newThang.unshift({ key: '', value: '---Tất cả ---' });
  }
  return newThang;
};

export const handleExportExcelFuncNew = (classId, datatable, docName) => {
  const dataTime = Moment(new Date()).format('DD_MM_YYYY_HH_ss');
  const styles = `<style>
      .rotate { mso-rotate: 90; white-space:nowrap }
      .rotate-90 { mso-rotate: -90; white-space:nowrap }
      table tr td {border: thin solid #000 !important; color: #393939 !important; background-color: #fff !important}
      table tr.noBorder td {border: 0 !important }
    </style>`;
  const template = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8" /><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->${styles}</head><body>${datatable}</body></html>`;
  const myBlob = new Blob([template], {
    type: 'application/vnd.ms-excel;charset=utf-8,'
  });
  const url = window.URL.createObjectURL(myBlob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = `${docName}_${dataTime}.xls`;
  a.click();
  window.URL.revokeObjectURL(url);
};

/**
 * get : hàm get custom theo lodash
 * @param {object} obj
 * @param {string} path
 * @param {any} defaultValue
 */
export const get = (obj = {}, path = '', defaultValue) => getLodash(obj, path, defaultValue);

/**
   *renderTrangThai: hiển thị trạng thái
   *@param {string} value
   */
export const renderTrangThai = (value) => {
  switch (value) {
    case true:
      return 'Đã duyệt';
    case false:
      return 'Chờ duyệt';
    default:
      return 'Mới tạo';
  }
};

/**
   *renderTrangThai: hiển thị trạng thái
   *@param {string} value
   */
export const renderTrangThaiBaoCao = (value) => {
  switch (value) {
    case 'DUYET':
      return 'Đã duyệt';
    case 'YEUCAUSUA':
      return 'Yêu cầu sửa';
    case 'CHODUYET':
      return 'Chờ duyệt';
    default:
      return 'Chưa tạo';
  }
};

/**
 *handleTrangThai: hiển thị trạng thái
 * @param {data} data
 */
// eslint-disable-next-line consistent-return
export const handleTrangThai = (data) => {
  if (data.length > 0) {
    if (data.every((item) => item.trangThaiDuyet === 'DUYET')) {
      return 'DUYET';
    } if (data.some((item) => item.trangThaiDuyet === 'CHODUYET')) {
      return 'CHODUYET';
    } if (data.some((item) => item.trangThaiDuyet === 'YEUCAUSUA')) {
      return 'YEUCAUSUA';
    }
  } else {
    return 'CHUA_TAO';
  }
};

/**
   * renderTrangThaiBaoCaoTable: hiển thị trạng thái trên table
   * @param {data} value
   */
// eslint-disable-next-line react/no-multi-comp
export const renderTrangThaiBaoCaoTable = (value) => {
  switch (value) {
    case 'DUYET':
      return <span style={{ color: 'green' }}>Đã duyệt</span>;
    case 'YEUCAUSUA':
      return <span style={{ color: 'red' }}>Yêu cầu sửa</span>;
    case 'CHODUYET':
      return <span style={{ color: 'blue' }}>Chờ duyệt</span>;
    default:
      return <span style={{ color: 'red' }}>Chưa tạo</span>;
  }
};

/**
 * renderSTTHo: hiển thị STT hộ
 * @param {array} data
 */
export const renderSTTHo = (data) => {
  const rs = data.map((item, index) => {
    if (item.sttThanhVien === '1') {
      return { ...item, sttHo: item.sttHo };
    }
    return { ...item, sttHo: '' };
  });
  return rs;
};

/**
 * renderSTTHoExcel: hiển thị STT hộ khi xuất excel
 * @param {array} data
 */
export const renderSTTHoExcel = (data) => {
  let sttHo = '';
  let maThon;
  const rs = data.map((item, index) => {
    if (sttHo === item.sttHo && item.maThon === maThon) {
      return { ...item, sttHo: '' };
    }
    sttHo = item.sttHo;
    maThon = item.maThon;
    return item;
  });
  return rs;
};

/**
 * getFileName: get tên file
 * @param {Object} value
 */
export const getFileName = (value) => value.split('/').pop().split('#')[0].split('?')[0];

/**
 * renderDataFile: convert list file để hiển thị lên control Upload
 * @param {array} dataFile
 */
export const renderDataFile = (dataFile) => map(dataFile, (item, index) => ({
  uid: index,
  name: decodeURI(getFileName(item)),
  status: 'done',
  url: item
}));

/**
 * onDownloadConTrol: tải file trên control
 * @param {Object} file
 */
export const onDownloadConTrol = (file, type) => {
  let fileURL = '';
  let fileName = '';
  if (type !== 'new') {
    fileName = file.url ? getFileName(file.url) : getFileName(file.name);
    // eslint-disable-next-line no-nested-ternary
    fileURL = file.url
      ? file.url : (file.response && file.response.fileDownloadUri ? file.response.fileDownloadUri : '');
  } else {
    fileName = file.name ? getFileName(file.name) : getFileName(file.url);
    fileURL = file.response.fileDownloadUri;
  }
  fetch(`${fileURL}`,
    {
      headers: {
        Authorization: 'Bearer '.concat(cookie.load('accessTokenBDT'))
      }
    })
    .then((response) => {
      response.blob().then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = boDauTiengViet(decodeURI(fileName));
        a.click();
      });
    });
};

/**
 * renderNgaySinh: hiển thị năm sinh hoặc ngày sinh
 * @param {object} item
 */
export const renderNgaySinh = (item) => {
  if (item.ngaySinh === 0) {
    return (item.namSinh);
  }
  return longToDate(item.ngaySinh);
};

/**
 * isCheckExcel : hiển thị check xuất excel
 */
// eslint-disable-next-line react/no-multi-comp
export const isCheckExcel = (check) => (
  check === true ? <span>&#10003;</span> : null
);

/**
 * renderTrieuDong : hiển thị tiền đơn vị triệu đồng
 */
export const renderTrieuDong = (number) => {
  if (Number.isNaN(number)) {
    return '';
  }
  const value = number * 1000000;
  return value.toLocaleString('vi-VN', {
    currency: 'VND'
  });
};

/**
* renderKyBaoCao: Hiển thị kỳ báo cáo
* @param {int} item
*/
export const renderKyBaoCao = (item) => {
  const baoCao = item || '';
  switch (baoCao) {
    case 1:
      return 'Quý 1';
    case 2:
      return '6 tháng';
    case 3:
      return '9 tháng';
    case 4:
      return 'Năm';
    default:
      return '';
  }
};
